// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OxJr2","left":"styles_left__Fn_Ly"};